import styled, { css } from "styled-components";
import { COLORS } from "../../styles/colors";
import { breakpoint } from "../../styles/constants";

export interface WxSelectProps {
  label: string;
  disabled?: boolean;
  selected?: boolean;
  darkMode?: boolean;
  onSelect: () => void;
  crossed?: boolean;
}

const WxSelect = ({
  label,
  disabled = false,
  selected = false,
  darkMode = false,
  crossed = false,
  onSelect,
}: WxSelectProps) => {
  return (
    <LabelContainer
      data-type={selected ? "selected" : disabled ? "disabled" : "neutral"}
      darkMode={darkMode}
      long={(label?.length ?? 0) > 3}
    >
      <div>
        {!disabled && crossed && <DisabledLine />}
        <input
          type="checkbox"
          onClick={onSelect}
          name={label}
          disabled={disabled}
          role="switch"
          value={`${selected}`}
          aria-label={label}
          aria-checked={selected}
        />
        <span>{label}</span>
      </div>
    </LabelContainer>
  );
};

const LabelContainer = styled.label<{ darkMode: boolean; long: boolean }>`
  --text-color: ${({ darkMode }) => (darkMode ? COLORS.white : COLORS.black)};
  --bg-color: ${({ darkMode }) => (darkMode ? COLORS.black : COLORS.white)};

  width: 28px;
  height: 28px;

  position: relative;
  font-size: 0.75rem;
  @media (min-width: ${breakpoint}) {
    font-size: 0.875rem;
    ${({ long }) =>
      long &&
      css`
        font-size: 0.5rem;
      `}
  }

  ${({ long }) =>
    long &&
    css`
      font-size: 0.5rem;
    `}

  text-align: center;
  text-transform: uppercase;
  border: 1px solid
    ${({ darkMode }) => (darkMode ? COLORS.white : COLORS.black)};
  background-color: var(--bg-color);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  span {
    color: var(--text-color);
  }

  input {
    position: absolute;
    overflow: hidden;
  }

  &[data-type="selected"] {
    --bg-color: ${({ darkMode }) => (darkMode ? COLORS.white : COLORS.black)};
    --text-color: ${({ darkMode }) => (darkMode ? COLORS.black : COLORS.white)};
  }

  &[data-type="disabled"] {
    cursor: default;
    opacity: 0.3;
    pointer-events: none;
  }
`;

const DisabledLine = styled.div`
  transform: rotate(-45deg);
  transform-origin: right;
  right: 0;
  border-top: 1px solid ${COLORS.red};
  width: 141.5%;
  position: absolute;
  top: 0;
`;

export default WxSelect;
